import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ToolbarService {
  private loggedInStatus = new BehaviorSubject<boolean>(false);
  loggedInStatus$ = this.loggedInStatus.asObservable();

  private customer = new BehaviorSubject<any>(null);
  customer$ = this.customer.asObservable();

  constructor() { }

  updateLoggedInStatus(isLoggedIn: boolean): void {
    this.loggedInStatus.next(isLoggedIn);
  }

  updateCustomer(customer: any): void {
    this.customer.next(customer);
  }
}
